import log from 'loglevel';
import { router } from '../services'

const validateContract = async (contractNumber, credentials) => {
  const payload = {
    contractNumber,
    type: 'CM',
  }

  try {
    const valaidationResponse = await router(
      'ValidationContract',
      payload,
      credentials,
    )
    return valaidationResponse
  } catch (err) {
    log.error(err)
    return err
  }
}

export default validateContract;
